<template>
  <div class="build editor-shell" :class="'editor-theme--' + editorTheme">
    <div v-if="editorVersionSwitching" class="editor-version-switch-mask" role="status" aria-live="polite"><i class="el-icon-loading" aria-hidden="true"></i> 正在切换草稿…</div>
    <imglist ref="imglist"
           @change="handleSetimg"></imglist> <!--背景图上传弹框-->
    <top ref="top"></top> <!-- 顶部选项栏-->
    <div class="app"
         :class="{'app--none':!menuFlag, 'is-palette-open': paletteVisible, 'is-inspector-open': inspectorVisible}">
      <div v-if="isComponentTemplateEditing && templateSaveBlocked" class="editor-template-save-alert" role="alert"><span>{{ templateSaveBlocked }}</span><el-button size="mini" :disabled="editorSaveInProgress" @click="$refs.top.reloadTemplate()">重新加载模板</el-button></div>
      <!--左边导航栏——图层    menuFlag控制是否显示左右两端-->
      <palette ref="palette" v-show="menuFlag && paletteVisible"></palette>
      <!--中间操作栏-->
      <container ref="container"></container>

      <div class="menu params"
           v-show="menuFlag && inspectorVisible" role="complementary" aria-label="编辑属性">
        <el-tabs class="tabs"
                 stretch
                 v-model="tabsActive">
          <el-tab-pane name="0">
            <span slot="label">属性</span>
            <el-form label-width="120px"
                     label-position="left"
                     size="mini">
              <!-- 组件配置 -->
              <template v-if="!vaildProp('',[undefined])">
                <p class="title">{{activeObj.title}}</p>
                <el-form-item label="图层名称">
                  <avue-input v-model="activeObj.name"></avue-input>
                </el-form-item>
                <el-form-item label="隐藏">
                  <avue-switch v-model="activeObj.display"></avue-switch>
                </el-form-item>
                <el-form-item v-if="!isComponentTemplateEditing" label="锁定">
                  <el-switch v-model="activeObj.locked" aria-label="锁定组件"></el-switch>
                </el-form-item>
                <template v-if="vaildProp('colorList')">
                  <el-form-item label="系统配色">
                    <avue-switch v-model="activeOption.switchTheme"></avue-switch>
                  </el-form-item>
                  <el-form-item label="配色选择"
                                v-if="activeOption.switchTheme">
                    <avue-select v-model="activeOption.theme"
                                 :dic="dicOption.themeList">
                    </avue-select>
                  </el-form-item>
                </template>
                <component :is="activeComponent.prop+'Option'"></component>
                <echarts-option-settings v-if="supportsEchartsOption(activeComponent.name)" :key="activeObj.index" :node="activeObj" :disabled="activeLayoutLocked"></echarts-option-settings>
                <main-option></main-option>
              </template>
              <!-- 多选配置选项 -->
              <template v-else-if="isFolder">
                <h2 class="editor-panel-heading">文件组属性</h2>
                <el-form-item label="图层名称"><avue-input v-model="activeObj.name"></avue-input></el-form-item>
                <el-form-item v-if="!isComponentTemplateEditing" label="锁定文件组"><el-switch v-model="activeObj.locked"></el-switch></el-form-item>
                <el-button size="mini" @click="$refs.contentmenu.handleLogout()">解散文件组</el-button>
              </template>
              <template v-else-if="isSelectActive">
                <el-form-item label="水平方式">
                  <el-tooltip content="左对齐"
                              placement="top">
                    <i class="el-icon-s-fold icon"
                       @click="$refs.container.handlePostionSelect('left')"></i>
                  </el-tooltip>
                  <el-tooltip content="居中对齐"
                              placement="top">
                    <i class="el-icon-s-operation icon"
                       @click="$refs.container.handlePostionSelect('center')"></i>
                  </el-tooltip>
                  <el-tooltip content="右对齐"
                              placement="top">
                    <i class="el-icon-s-unfold icon"
                       @click="$refs.container.handlePostionSelect('right')"></i>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="垂直方式">
                  <el-tooltip content="顶对齐"
                              placement="top">
                    <i class="el-icon-s-fold icon"
                       @click="$refs.container.handlePostionSelect('top')"></i>
                  </el-tooltip>
                  <el-tooltip content="中部对齐"
                              placement="top">
                    <i class="el-icon-s-operation icon"
                       @click="$refs.container.handlePostionSelect('middle')"></i>
                  </el-tooltip>
                  <el-tooltip content="底对齐"
                              placement="top">
                    <i class="el-icon-s-unfold icon"
                       @click="$refs.container.handlePostionSelect('bottom')"></i>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button type="primary"
                             size="mini"
                             class="block"
                             @click="handleDeleteSelect">删除</el-button>
                </el-form-item>
                <el-form-item label-width="0">
                  <el-button type="danger"
                             size="mini"
                             class="block"
                             @click="handleFloder">新建文件组</el-button>
                </el-form-item>
              </template>
              <!-- 主屏的配置项 -->
              <template v-else-if="isComponentTemplateEditing">
                <h2 class="editor-panel-heading">{{ isComponentResourceEditing ? '组件样式' : '组件样式模板' }}</h2>
                <p class="editor-page-settings-hint">选择画布中的组件修改颜色、字体和尺寸；可添加受支持的组件组成组合。保存按所有组件的外边界计算样式尺寸。</p>
                <p class="editor-page-settings-hint">这里只保存样式和静态示例，不保存设备身份、接口或脚本。保存新版本不会改变已拖入大屏的副本。</p>
              </template>
              <template v-else>
                <h2 class="editor-panel-heading">页面配置</h2>
                <el-form-item label-width="0">
                  <div class="editor-canvas-dimensions" role="group" aria-label="画布宽高">
                    <div class="editor-canvas-dimension">
                      <span aria-hidden="true">W</span>
                      <el-input-number :key="'width-' + activePageId + '-' + pageDimensionRevision" :value="Number(config.width)" :min="1" :controls="false" label="画布宽度 W，单位像素" @change="setPageDimension('width', $event)"></el-input-number>
                    </div>
                    <div class="editor-canvas-dimension">
                      <span aria-hidden="true">H</span>
                      <el-input-number :key="'height-' + activePageId + '-' + pageDimensionRevision" :value="Number(config.height)" :min="1" :controls="false" label="画布高度 H，单位像素" @change="setPageDimension('height', $event)"></el-input-number>
                    </div>
                  </div>
                  <span v-if="pageDimensionError" class="editor-upload-hint editor-upload-error" role="alert">{{ pageDimensionError }}</span>
                </el-form-item>
                <el-form-item label="画布尺寸" label-width="76px">
                  <div class="editor-page-segments" role="group" aria-label="画布尺寸预设">
                    <button v-for="preset in canvasSizePresets" :key="preset.value" type="button" :aria-pressed="pageCanvasSize === preset.value" :aria-label="preset.width ? preset.label + ' ' + preset.width + ' × ' + preset.height : '自定义尺寸，保留当前宽高'" :title="preset.width ? preset.label + ' ' + preset.width + ' × ' + preset.height : '自定义尺寸，保留当前宽高'" @click="selectCanvasSize(preset.value)">
                      <i :class="preset.icon" aria-hidden="true"></i>
                      <span>{{ preset.label }}</span>
                    </button>
                  </div>
                </el-form-item>
                <el-form-item label="适配类型" label-width="76px">
                  <div class="editor-page-segments" role="group" aria-label="页面适配类型" aria-describedby="page-fit-note">
                    <button v-for="fit in pageFitTypes" :key="fit" type="button" :aria-pressed="pageFitType === fit" @click="selectPageFit(fit)">{{ fit }}</button>
                  </div>
                </el-form-item>
                <div class="editor-page-fit-example">
                  <div class="editor-page-fit-viewport" aria-hidden="true"><span :style="pageFitPreviewStyle"></span></div>
                  <div><strong>适配示意 · {{ pageFitType }}</strong><p>{{ pageFitDescription }}</p></div>
                </div>
                <p id="page-fit-note" class="editor-page-settings-hint">适配选项随“保存”记录，发布到平台菜单后按所选方式适配。独立预览/查看仍按页面宽高 100% 展示。改宽高只延长或缩短画布，不缩放组件。</p>
                <el-form-item label="背景颜色" label-width="76px">
                  <avue-input-color v-model="config.backgroundColor"></avue-input-color>
                </el-form-item>
                <el-form-item label="背景图片" label-width="76px">
                  <el-upload class="editor-background-upload" action="/jetlinks/file/static" accept="image/png,image/jpeg,image/webp,image/gif" :show-file-list="false" :before-upload="checkBackgroundFile" :http-request="uploadBackground" :disabled="backgroundUploading">
                    <button type="button" class="editor-background-button" aria-label="上传背景图片" :disabled="backgroundUploading">
                      <img v-if="config.backgroundImage" :src="config.backgroundImage" alt="当前背景图片" />
                      <i v-else :class="backgroundUploading && backgroundUploadPageId === activePageId ? 'el-icon-loading' : 'el-icon-plus'"></i>
                    </button>
                  </el-upload>
                  <span class="editor-upload-hint">PNG / JPG / WebP / GIF，最大 10 MB</span>
                  <span v-if="backgroundUploading" class="editor-upload-hint" role="status">{{ backgroundUploadPageId === activePageId ? backgroundUploadFile + ' · 上传中 ' + (backgroundUploadProgress === null ? '' : backgroundUploadProgress + '%') : '其他页面背景图正在上传，请等待' }}</span>
                  <span v-if="backgroundUploadError" class="editor-upload-hint editor-upload-error" role="alert">{{ backgroundUploadError }}，可点击重新选择</span>
                  <el-button v-if="config.backgroundImage" type="text" size="mini" @click="config.backgroundImage = ''">移除背景图</el-button>
                </el-form-item>
                <template v-if="!isTemplateEditing">
                <h2 class="editor-panel-heading">更多配置</h2>
                <el-form-item label="大屏简介">
                  <avue-input v-model="config.info" type="textarea" :min-rows="2"></avue-input>
                </el-form-item>
                <el-form-item label="环境地址">
                  <avue-input type="textarea"
                              :min-rows="2"
                              v-model="config.url"></avue-input>
                </el-form-item>
                <el-form-item label="参数">
                  <el-button size="mini"
                             type="primary"
                             @click="openCode('query')">编辑</el-button>
                </el-form-item>
                <template>
                  <el-form-item label="警告弹框">
                    <el-switch v-model="config.isWarning" active-color="#13ce66"></el-switch>
                  </el-form-item>
                  <el-form-item label="数据类型" v-if="config.isWarning">
                    <el-radio-group v-model="config.warnType">
                      <el-radio :label="0">全部数据</el-radio>
                      <el-radio :label="1">设备数据</el-radio>
                      <el-radio :label="2">产品数据</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="选择设备" v-if="config.warnType === 1">
                    <el-button size="mini"
                               type="primary"
                               @click="deviceVisible=true;">编辑</el-button>
                  </el-form-item>
                  <el-form-item label="选择产品" v-if="config.warnType === 2">
                    <el-button size="mini"
                               type="primary"
                               @click="deviceVisible=true;">编辑</el-button>
                  </el-form-item>
                </template>
                <template v-if="config.mark.show">
                  <el-form-item label="内容">
                    <avue-input v-model="config.mark.text"></avue-input>
                  </el-form-item>
                  <el-form-item label="大小">
                    <avue-input-number v-model="config.mark.fontSize"></avue-input-number>
                  </el-form-item>
                  <el-form-item label="颜色">
                    <avue-input-color v-model="config.mark.textStyle"></avue-input-color>
                  </el-form-item>
                  <el-form-item label="角度">
                    <avue-input-number v-model="config.mark.degree"></avue-input-number>
                  </el-form-item>
                </template>
                </template>
              </template>
            </el-form>
          </el-tab-pane>
          <!-- 数据配置 -->
          <el-tab-pane name="1"
                       v-if="vaildProp('dataList') || ['productList', 'deviceList', 'map', 'Dmap'].includes(activeComponent.prop)">
            <span slot="label">数据</span>
            <p v-if="isComponentTemplateEditing && ['productList', 'deviceList'].includes(activeComponent.prop)" class="editor-page-settings-hint">列表样式只保存外观及搜索、分页显示选项，不保存真实产品或设备记录。产品范围与数据来源在拖入大屏后配置。</p>
            <fleet-list-data v-else-if="['productList', 'deviceList'].includes(activeComponent.prop)" :key="activeObj.index"></fleet-list-data>
             <map-location-data v-if="!isComponentTemplateEditing && ['map', 'Dmap'].includes(activeComponent.prop)" :key="'map-' + activeObj.index" />
             <p v-if="activeComponent.prop === 'text' && ['pageProduct', 'pageDevice', 'pageDeviceId'].includes(activeOption.textSource)" class="editor-page-settings-hint">当前文本使用页面传入的产品／设备参数，前后文字和编辑示例在“属性”中设置，不使用下方原有数据源。</p>
             <el-form v-if="!['productList', 'deviceList'].includes(activeComponent.prop) && activeObj.dataType !== 5 && !(activeComponent.prop === 'text' && ['pageProduct', 'pageDevice', 'pageDeviceId'].includes(activeOption.textSource))" class="device-chart-data-settings" label-width="120px"
                     label-position="left"
                     size="mini">
              <el-form-item label="数据类型">
                <el-radio-group v-model="activeObj.dataType">
                  <el-radio :label="0">静态数据</el-radio>
                  <template v-if="!isComponentTemplateEditing">
                    <el-radio :label="1">动态数据</el-radio>
                    <el-radio :label="4">webSocket</el-radio>
                    <el-radio :label="2" v-if="vaildProp('deviceList')">设备数据</el-radio>
                    <el-radio :label="3">脚本数据</el-radio>
                    <el-radio v-if="['text', 'line', 'bar', 'pie', 'progress'].includes(activeComponent.prop)" :label="6">充电桩统计</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
              <charging-statistics-settings v-if="!isComponentTemplateEditing && activeObj.dataType === 6" :key="'charging-' + activeObj.index" />
              <p v-if="isComponentTemplateEditing" class="editor-page-settings-hint">静态示例用于查看样式，随样式保存；实际设备、接口和页面交互在大屏实例中配置。</p>
              <el-form-item label="数据值"
                            label-position="top"
                            v-if="activeObj.dataType===0">
                <el-button size="mini"
                           type="primary"
                           @click="openCode('data')">编辑</el-button>
              </el-form-item>
              <template v-if="!isComponentTemplateEditing && activeObj.dataType===1">
                <el-form-item label="接口地址">
                  <avue-input type="textarea"
                              :min-rows="6"
                              v-model="activeObj.url"></avue-input>
                </el-form-item>
                <el-form-item label="接口方式"
                              v-if="activeObj.dataType===1">
                  <avue-radio v-model="activeObj.dataMethod"
                              :dic="dicOption.dataMethod"></avue-radio>
                </el-form-item>
                <el-form-item label="接口参数"
                              v-if="activeObj.dataType===1">
                  <el-button size="mini"
                             type="primary"
                             @click="openCode('dataQuery')">编辑</el-button>
                </el-form-item>
                <el-form-item label="刷新时间">
                  <avue-input-number v-model="activeObj.time"></avue-input-number>
                </el-form-item>
              </template>
              <template v-if="!isComponentTemplateEditing && activeObj.dataType===2">
                <el-form-item v-if="activeHasDeviceBinding" label="设备来源">
                  <el-radio-group v-model="chartDeviceSource">
                    <el-radio label="fixed">固定设备</el-radio>
                    <el-radio label="page">当前页面设备</el-radio>
                  </el-radio-group>
                  <p v-if="chartDeviceSource === 'page'" class="device-chart-hint">运行时使用上级页面传入的 deviceId，不会回退到示例设备。</p>
                </el-form-item>
                <el-form-item v-if="activeHasDeviceBinding && chartDeviceSource === 'page'" label="属性所属产品">
                  <el-select v-model="activeParameter.productId" filterable clearable :loading="chartProductsLoading"
                             placeholder="选择用于配置属性的产品" @focus="loadChartProducts()" @change="selectChartProduct">
                    <el-option v-for="product in chartProducts" :key="product.id" :label="product.name || product.id" :value="product.id"></el-option>
                  </el-select>
                  <p class="device-chart-hint">产品用于选择物模型属性，不固定运行时设备。</p>
                  <p v-if="chartProductsError" class="device-chart-config-error" role="alert">{{ chartProductsError }} <el-button type="text" @click="loadChartProducts(true)">重试</el-button></p>
                </el-form-item>
                <el-form-item :label="activeHasDeviceBinding && chartDeviceSource === 'page' ? '编辑示例设备' : '设备'">
                  <el-input v-model="activeParameter.deviceName" readonly @change="deviceChange()"></el-input>
                  <el-button size="mini"
                             type="primary"
                             @click="dialogVisible=true; getDeviceList(1);">编辑</el-button>
                </el-form-item>
                <template>
                  <template v-if="activeComponent.prop==='Player'">
                    <el-form-item label="视频类型">
                      <avue-select v-model="activeObj.data.type" :dic="dicOption.sourceTypeList"></avue-select>
                    </el-form-item>
                    <el-form-item label="来源类型">
                      <el-select v-model="activeParameter.sourceType" @change="sourceChange()">
                        <el-option value="property" label="属性"></el-option>
                        <el-option value="function" label="功能"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="来源功能" v-if="activeParameter.sourceType === 'function'">
                      <el-select v-model="activeParameter.function">
                        <el-option v-for="item in functionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="来源属性" v-if="activeParameter.sourceType === 'property'">
                      <el-select v-model="activeParameter.property">
                        <el-option v-for="item in otherPropertyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                  <template v-else>
                    <el-form-item label="属性">
                      <el-select v-if="activeHasDeviceBinding" v-model="activeParameter.property" clearable filterable
                                 :loading="chartMetadataLoading" placeholder="选择设备属性" @change="selectChartProperty">
                        <el-option v-for="item in chartPropertyOptions" :key="item.id" :label="item.name + ' (' + item.id + ')'" :value="item.id"></el-option>
                      </el-select>
                      <el-select v-else v-model="activeParameter.property" clearable>
                        <el-option v-for="item in propertyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                      <p v-if="activeHasDeviceBinding && activeParameter.propertyType" class="device-chart-hint">类型：{{ activeParameter.propertyType }}<span v-if="activeParameter.propertyUnit"> · 单位：{{ activeParameter.propertyUnit }}</span></p>
                      <p v-if="activeHasDeviceBinding && chartMetadataError" class="device-chart-config-error" role="alert">{{ chartMetadataError }} <el-button type="text" @click="loadChartMetadata()">重试</el-button></p>
                    </el-form-item>
                  </template>
                </template>
                <p v-if="activeIsDeviceValue" class="device-chart-hint">属性值直接由 WS 订阅获取，先带回一条已有记录，再推送实时值，不额外 HTTP 读取或轮询。安全预览仅 HTTP 只读一次，不建立订阅。</p>
                <p v-if="activeIsDeviceValue && activeComponent.prop === 'gauge'" class="device-chart-hint">默认选择数值属性，量程沿用组件数据值中的 min / max。自定义处理可转换其他类型，返回需包含数值 value。</p>
                <p v-if="activeIsDeviceValue && activeObj.dataFormatter" class="device-chart-hint">处理函数沿用 value.payload.value.value / formatValue / unit，返回 { value: ... }；仪表盘可同时返回 min、max、unit。安全预览不执行脚本。</p>
                <template v-if="activeIsDeviceChart">
                  <el-form-item label="类型">
                    <avue-select v-model="activeParameter.configDataType"
                                 :dic="dicOption.configDataType">
                    </avue-select>
                  </el-form-item>
                  <el-form-item label="数据上限">
                    <el-input-number v-model="chartDataLimit" :min="1" :max="10000" :precision="0" controls-position="right"></el-input-number>
                    <p class="device-chart-hint">明细和实时数据取所选区间内最近 N 条，接续后保留最近 N 个点；聚合保留最近 N 个时间桶。旧配置的 0 按 200 条处理。</p>
                  </el-form-item>
                  <p v-if="activeParameter.configDataType == 2" class="device-chart-hint">先 HTTP 回补所选时间区间，再由 WS 追加。区间与点数上限分别生效，不定时全量刷新。</p>
                  <el-form-item v-else label="接续实时数据">
                    <el-switch v-model="chartLiveFollow" aria-label="接续实时数据"></el-switch>
                    <p class="device-chart-hint">开启后先 HTTP 查询，随后由 WS 更新；旧图表默认不自动开启。安全预览只查询历史，不建立 WS。</p>
                  </el-form-item>
                    <el-form-item label="区间方式">
                      <el-radio-group v-model="chartRangeMode">
                        <el-radio label="relative">相对区间</el-radio>
                        <el-radio label="fixed">固定区间</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="chartRangeMode === 'relative'" label="时间范围">
                      <el-select v-model="chartTimePreset" placeholder="选择快捷区间，也可填写表达式">
                        <el-option label="最近 1 小时" value="now-1h"></el-option>
                        <el-option label="最近 24 小时" value="now-1d"></el-option>
                        <el-option label="最近 7 天" value="now-7d"></el-option>
                        <el-option label="最近 30 天" value="now-30d"></el-option>
                      </el-select>
                      <el-input v-model="activeParameter.from" aria-label="开始时间表达式" placeholder="开始，如 now-7d"></el-input>
                      <el-input v-model="activeParameter.to" aria-label="结束时间表达式" placeholder="结束，留空为 now"></el-input>
                      <p class="device-chart-hint">首次查询计算相对区间；支持 now-1h、now-7d。接续时结束为 now 会继续追加，点数超限移除最早点；其他结束表达式为封闭区间。</p>
                    </el-form-item>
                    <el-form-item v-else label="时间范围">
                      <el-date-picker v-model="chartFixedFrom" type="datetime" value-format="timestamp" placeholder="开始时间" aria-label="开始时间"></el-date-picker>
                      <el-date-picker v-model="chartFixedTo" type="datetime" value-format="timestamp" placeholder="结束时间" aria-label="结束时间"></el-date-picker>
                      <p class="device-chart-hint">按浏览器本地时区选择时间；结束时间必须晚于开始时间。</p>
                    </el-form-item>
                    <el-form-item label="时间格式">
                      <el-input v-model="activeParameter.format" placeholder="yyyy-MM-dd HH:mm:ss"></el-input>
                    </el-form-item>
                    <el-form-item v-if="activeParameter.configDataType != 2 && !chartLiveFollow" label="自动刷新(ms)">
                      <el-input-number v-model="chartRefreshInterval" :min="0" :step="1000" :precision="0" controls-position="right"></el-input-number>
                      <p class="device-chart-hint">0 为关闭；仅正式查看时自动刷新，编辑和安全预览不轮询。</p>
                    </el-form-item>
                  <template v-if="activeParameter.configDataType == 1">
                    <el-form-item label="聚合类型">
                      <avue-select v-model="activeParameter.aggregationType"
                                   :dic="dicOption.aggregationType">
                      </avue-select>
                    </el-form-item>
                    <el-form-item label="时间间隔">
                      <el-input v-model="chartInterval" placeholder="例如 10m、1h、1d"></el-input>
                      <p class="device-chart-hint">COUNT 统计记录数量，不是属性数值之和。</p>
                      <p v-if="chartLiveFollow" class="device-chart-hint">同一时间桶更新当前点，跨桶才新增点。AVG 使用累计 SUM / COUNT；迟到、修正数据及日历桶按需局部查询校准，不轮询整张图。</p>
                    </el-form-item>
                  </template>
                  <el-form-item v-if="activeObj.dataFormatter && activeParameter.configDataType != 2" label="处理函数输入">
                    <el-select v-model="chartFormatterInput">
                      <el-option label="兼容旧 dashboard 结构" value="legacy"></el-option>
                      <el-option label="原始接口响应" value="raw"></el-option>
                    </el-select>
                    <p class="device-chart-hint">旧设备配置兼容 result[].data.timeString 和 data.value.value；自定义处理后不再二次转换。动态接口的数据处理不变，安全预览不执行脚本。</p>
                  </el-form-item>
                  <p v-if="chartConfigError" class="device-chart-config-error" role="alert">{{ chartConfigError }}</p>
                </template>
              </template>
              <template v-if="!isComponentTemplateEditing && activeObj.dataType===3">
                <el-form-item label="脚本编辑">
                  <el-button size="mini"
                             type="primary"
                             @click="openCode('dataScript')">编辑</el-button>
                </el-form-item>
              </template>
              <template v-if="!isComponentTemplateEditing && activeObj.dataType===4">
                <el-form-item label="接口参数">
                  <el-button size="mini"
                             type="primary"
                             @click="openCode('dataQuery')">编辑</el-button>
                </el-form-item>
              </template>
              <el-form-item v-if="!isComponentTemplateEditing && activeObj.dataType !== 6" label="数据处理">
                <el-button size="mini"
                           type="primary"
                           @click="openCode('dataFormatter')">编辑</el-button>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button size="mini"
                           type="primary"
                           class="block"
                           @click="handleRefresh">刷新</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 交互事件配置 -->
          <el-tab-pane name="2"
                       v-if="!isComponentTemplateEditing && isActive && !isSelectActive && !isFolder && !['deviceProperty', 'deviceGroup', 'deviceStatus', 'componentTitle'].includes(activeComponent.prop)">
            <span slot="label">交互</span>
            <el-form label-width="120px"
                     label-position="left"
                     size="mini">
              <navigation-settings :key="activeObj.index"></navigation-settings>
              <template v-if="vaildProp('eventList')">
              <h2 class="editor-panel-heading">原有组件联动</h2>
              <el-form-item label="子类">
                <avue-select multiple
                             v-model="activeObj.child.index"
                             :dic="childList"
                             :props="childProps">
                </avue-select>
              </el-form-item>
              <el-form-item label="参数名称">
                <avue-input v-model="activeObj.child.paramName"></avue-input>
              </el-form-item>
              </template>
            </el-form>
          </el-tab-pane>
          <!-- 其他事件配置 -->
          <el-tab-pane name="3"
                       v-if="!isComponentTemplateEditing && vaildProp('formatterList')">
            <span slot="label">事件</span>
            <el-form label-width="120px"
                     label-position="left"
                     size="mini">
              <el-form-item label="提示事件">
                <el-button size="mini"
                           type="primary"
                           @click="openCode('formatter')">编辑</el-button>
              </el-form-item>
              <el-form-item label="点击事件"
                            v-if="vaildProp('clickFormatterList')">
                <el-button size="mini"
                           type="primary"
                           @click="openCode('clickFormatter')">编辑</el-button>

              </el-form-item>
              <el-form-item label="标题事件"
                            v-if="vaildProp('labelFormatterList')">
                <el-button size="mini"
                           type="primary"
                           @click="openCode('labelFormatter')">编辑</el-button>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button size="mini"
                           type="primary"
                           class="block"
                           @click="handleRefresh">刷新</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 基本参数配置 -->
          <el-tab-pane name="4"
                       v-if="isActive && !isSelectActive && !isFolder">
            <span slot="label">布局</span>
            <el-form label-width="120px"
                     label-position="left"
                     size="mini">
              <el-form-item label="序号">
                <avue-input v-model="activeObj.index"
                            disabled></avue-input>
              </el-form-item>
              <el-form-item label="X位置">
                <avue-input-number v-model="activeComponentLeft" :min="0" :max="Math.max(0, Number(config.width) - Number(activeComponent.width))" :disabled="activeLayoutLocked"></avue-input-number>
              </el-form-item>
              <el-form-item label="Y位置">
                <avue-input-number v-model="activeComponentTop" :min="0" :max="Math.max(0, Number(config.height) - Number(activeComponent.height))" :disabled="activeLayoutLocked"></avue-input-number>
              </el-form-item>
              <el-form-item label="宽度">
                <avue-input-number v-model="activeComponentWidth" :min="1" :max="Math.max(1, Number(config.width) - Math.max(0, Number(activeObj.left) || 0))" :disabled="activeLayoutLocked"></avue-input-number>
              </el-form-item>
              <el-form-item label="高度">
                <avue-input-number v-model="activeComponentHeight" :min="1" :max="Math.max(1, Number(config.height) - Math.max(0, Number(activeObj.top) || 0))" :disabled="activeLayoutLocked"></avue-input-number>
              </el-form-item>
              
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <codeedit @submit="codeClose"
              :type="code.type"
              v-model="code.obj"
              :visible.sync="code.box"></codeedit><!--代码编辑器-->
    <deviceedit @submit="deviceClose" :visible.sync="deviceVisible" :type="config.warnType" :data="config.deviceList"></deviceedit>
    <contentmenu ref="contentmenu"></contentmenu><!--图层操作框-->
    <el-dialog title="选择设备" :visible.sync="dialogVisible" width="60%">
      <div style="width: 96%; padding:0 2%">
        <div style="width: 100%">
          <el-form class="demo-form-inline" :inline="true">
            <el-form-item label="设备ID">
              <el-input placeholder="请输入设备ID" v-model="deviceId"></el-input>
            </el-form-item>
            <el-form-item label="设备名称">
              <el-input placeholder="请输入设备名称" v-model="deviceName"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getDeviceList(1)">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="background-color: #0c0c0c;">
          <el-table style="width: 100%" :data="deviceList.data" >
            <el-table-column align="center">
              <template slot-scope="scope">
                <el-radio :label="scope.row.id" v-model="device"><i></i></el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="ID" align="center"></el-table-column>
            <el-table-column prop="name" label="设备名称" align="center"></el-table-column>
            <el-table-column prop="productName" label="产品名称" align="center"></el-table-column>
           <el-table-column prop="registryTime" label="注册时间" align="center" :formatter="formatDate"></el-table-column>
            <el-table-column prop="state.text" label="状态" align="center"></el-table-column>
          </el-table>
          <div style="display: flex;justify-content: flex-end;padding: 20px 20px 20px 0;">
            <el-pagination layout="total, prev, pager, next, jumper" background :total="deviceList.total" :hide-on-single-page="true"
              @current-change="handleCurrentChange"
              :page-size="deviceList.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false; deviceId = ''; deviceName = ''">取 消</el-button>
        <el-button type="primary" @click="getProperties">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import palette from './group/palette';
import top from './group/top';
import imglist from './group/imglist'
import contentmenu from './group/contentmenu'
import codeedit from './group/code';
import deviceedit from "@/page/group/device";
import { dicOption } from '@/option/config'
import init from '@/mixins/'
import pages from '@/mixins/pages'
import pageSettings from '@/mixins/page-settings'
import deviceChartSettings from '@/mixins/device-chart-settings'
import legacyDeviceSettings from '@/mixins/legacy-device-settings'
import editorSaveState from '@/mixins/editor-save-state'
import { encodeQueryParam } from '@/utils/utils'
import components from '@/option/components'
import EchartsOptionSettings from '@/option/components/echarts-option'
import { supportsEchartsOption } from '@/editor/core/echarts-option'
import NavigationSettings from './group/navigation-settings'
import FleetListData from '@/components/FleetList/data'
import MapLocationData from '@/components/DeviceMap/data'
import ChargingStatisticsSettings from '@/option/components/charging-statistics.vue'
import {deviceList} from '@/api/visual'
import request from '@/api/http'
import { isTextEditing, locateNode, canEditNode } from '@/editor/core/node-operations'
import { componentRect, resizedComponentRect } from '@/editor/core/component-size'
export default {
  mixins: [init, components, pages, pageSettings, deviceChartSettings, legacyDeviceSettings, editorSaveState],
  data () {
    return {
      device: "",
      dialogVisible: false,
      deviceVisible:false,
      deviceList: {},
      deviceId: '',
      deviceName: '',
      propertyList: [],
      functionList: [],
      otherPropertyList: [],
      keys: {
        ctrl: false,
      },
      loading: '',
      childProps: {
        label: 'name',
        value: 'index'
      },
      key: '',
      menuFlag: true,
      paletteVisible: true,
      inspectorVisible: true,
      editorTheme: 'dark',
      backgroundUploading: false,
      backgroundUploadPageId: '',
      backgroundUploadFile: '',
      backgroundUploadProgress: 0,
      backgroundUploadError: '',
      undoStack: [],
      redoStack: [],
      code: {
        box: false,
        type: '',
        obj: '',
      },
      form: {},
      dicOption: dicOption,
      tabsActive: '0',
    }
  },
  components: {
    EchartsOptionSettings,
    NavigationSettings,
    FleetListData,
    MapLocationData,
    ChargingStatisticsSettings,
    imglist,
    palette,
    codeedit,
    deviceedit,
    top,
    contentmenu
  },
  computed: {
    isFolder () {
      return this.activeObj.children
    },
    isActive () {
      return this.active.length !== 0
    },
    isSelectActive () {
      return this.active.length > 1;
    },
    childList () {
      return this.list.filter(ele => {
        return !['tabs'].includes(ele.component.prop);
      })
    },
    activeComponent () {
      return this.activeObj.component || {}
    },
    activeComponentWidth: {
      get () { return this.activeComponent.width },
      set (value) { this.setComponentGeometry('width', value) }
    },
    activeComponentHeight: {
      get () { return this.activeComponent.height },
      set (value) { this.setComponentGeometry('height', value) }
    },
    activeComponentLeft: {
      get () { return this.activeObj.left },
      set (value) { this.setComponentGeometry('left', value) }
    },
    activeComponentTop: {
      get () { return this.activeObj.top },
      set (value) { this.setComponentGeometry('top', value) }
    },
    activeLayoutLocked () {
      return !canEditNode(locateNode(this.nav, this.activeObj.index));
    },
    activeOption () {
      return this.activeObj.option || {}
    },
    activeParameter () {
      return this.activeObj.parameter || {}
    },
    activeObj () {
      let result;
      if (this.validatenull(this.active)) {
        return {}
      }
      this.active.forEach(ele => {
        const item = this.findnav(ele, true);
        if (this.active.length > 1) {
          if (!result) result = [];
          result.push(item.obj);
        } else {
          result = item.obj
        }
      });
      return result || {}
    }
  },
  watch: {
    nav: { deep: true, handler: 'scheduleHistory' },
    config: { deep: true, handler: 'scheduleHistory' },
    menuFlag () {
      this.setResize();
    },
    overactive (n, o) {
      [o, n].forEach((ele, index) => {
        if (!ele) return;
        this.setActive(ele, index === 1, 'setOverActive');
      })
    },
    active (n, o) {
      [o, n].forEach((ele, index) => {
        ele.forEach(item => {
          this.setActive(item, index === 1, 'setActive');
        })
      });
      //隐藏右键菜单
      if (this.$refs.contentmenu) this.$refs.contentmenu.hide();
      // 初始化选项卡
      this.tabsActive = '0';
    },
  },
  created () {
    if (this.$route.query.token) localStorage.setItem("x-access-token", this.$route.query.token);
    this.listen();
    this.getDeviceList(1);
    window.initWebSocket();
  },
  mounted () {
    this.initFun()
  },
  methods: {
    supportsEchartsOption,
    setComponentGeometry (axis, value) {
      if (this.activeLayoutLocked || !this.activeObj.component || !['width', 'height', 'left', 'top'].includes(axis)) return;
      if (value === undefined || value === null || value === '' || !Number.isFinite(Number(value))) return;
      const raw = { width: this.activeComponent.width, height: this.activeComponent.height,
        left: this.activeObj.left, top: this.activeObj.top, [axis]: Number(value) };
      const rect = ['width', 'height'].includes(axis)
        ? resizedComponentRect(raw, this.config, axis === 'width' ? 'right' : 'bottom') : componentRect(raw, this.config);
      this.$set(this.activeComponent, 'width', rect.width); this.$set(this.activeComponent, 'height', rect.height);
      this.$set(this.activeObj, 'left', rect.left); this.$set(this.activeObj, 'top', rect.top);
    },
    editorSnapshot () {
      if (this.pageProject && this.pageProject.pages.length) {
        this.syncActivePage();
        return JSON.stringify({ pageProject: this.pageProject, activePageId: this.activePageId });
      }
      return JSON.stringify({ nav: this.nav, config: this.config });
    },
    resetEditorHistory () {
      clearTimeout(this.historyTimer);
      this.historyBaseline = this.editorSnapshot();
      this.undoStack = [];
      this.redoStack = [];
    },
    scheduleHistory () {
      if (!this.projectRecord) return;
      if (this._editorFilterGesture) return;
      clearTimeout(this.historyTimer);
      this.historyTimer = setTimeout(this.rememberStructure, 250);
    },
    rememberStructure () {
      clearTimeout(this.historyTimer);
      if (!this.projectRecord) return;
      const next = this.editorSnapshot();
      if (this.historyBaseline && next !== this.historyBaseline) {
        this.undoStack.push(this.historyBaseline);
        this.redoStack = [];
        while (this.undoStack.length > 20 || (this.undoStack.length > 1 && this.undoStack.reduce((sum, value) => sum + value.length, 0) > 30 * 1024 * 1024)) this.undoStack.shift();
      }
      this.historyBaseline = next;
    },
    restoreEditorSnapshot (snapshot) {
      const model = JSON.parse(snapshot);
      this.historyBaseline = snapshot;
      this.handleInitActive();
      if (model.pageProject) {
        this.pageProject = model.pageProject;
        this.bindPage(model.activePageId);
      } else {
        this.nav = model.nav;
        this.config = model.config;
      }
    },
    undoStructure () {
      this.rememberStructure();
      if (!this.undoStack.length) return;
      this.redoStack.push(this.editorSnapshot());
      this.restoreEditorSnapshot(this.undoStack.pop());
    },
    redoStructure () {
      this.rememberStructure();
      if (!this.redoStack.length) return;
      this.undoStack.push(this.editorSnapshot());
      this.restoreEditorSnapshot(this.redoStack.pop());
    },
    checkBackgroundFile (file) {
      const valid = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'].includes(file.type) && file.size <= 10 * 1024 * 1024;
      this.backgroundUploadError = valid ? '' : '请上传 10 MB 以内的 PNG、JPG、WebP 或 GIF 图片';
      return valid;
    },
    async uploadBackground ({ file }) {
      if (this.backgroundUploading) return;
      const projectId = this.id;
      const pageId = this.activePageId;
      const originalConfig = this.config;
      this.backgroundUploading = true;
      this.backgroundUploadPageId = pageId;
      this.backgroundUploadFile = file.name;
      this.backgroundUploadProgress = 0;
      this.backgroundUploadError = '';
      const form = new FormData();
      form.append('file', file);
      try {
        // 项目旧 Mock.js 的 XHR.upload 是空对象；不能向它绑定 progress 事件。
        const upload = new window.XMLHttpRequest().upload;
        const supportsProgress = upload && typeof upload.addEventListener === 'function';
        if (!supportsProgress) this.backgroundUploadProgress = null;
        const options = supportsProgress ? { onUploadProgress: event => {
            if (event.total) this.backgroundUploadProgress = Math.round(event.loaded / event.total * 100);
          } } : {};
        const response = await request.post('/jetlinks/file/static', form, options);
        const url = response.data && response.data.result;
        if (typeof url !== 'string' || !url) throw new Error('上传接口未返回有效图片地址');
        if (!this._isDestroyed && this.id === projectId) {
          const page = this.pageProject.pages.find(page => page.id === pageId);
          // 上传过程中切页时只更新来源页；来源页已删除则丢弃结果。
          if (page && page.config === originalConfig) this.$set(page.config, 'backgroundImage', url);
          else if (!pageId && this.config === originalConfig) this.$set(this.config, 'backgroundImage', url);
        }
        return response.data;
      } catch (error) {
        if (!this._isDestroyed && this.id === projectId && this.activePageId === pageId && this.config === originalConfig) this.backgroundUploadError = error.message || '背景图上传失败';
        throw error;
      } finally { this.backgroundUploading = false; }
    },
    deviceChange(){
      this.activeParameter.property = ''
      this.activeParameter.function = ''
    },
    sourceChange(){
      this.activeParameter.property = ''
      this.activeParameter.function = ''
    },
    handleCurrentChange(currentPage){
      this.getDeviceList(currentPage)
    },
    getDeviceList(currentPage){
      deviceList(encodeQueryParam({
        pageSize: 10,
        pageIndex: currentPage - 1,
        terms: {
          id$LIKE: this.deviceId,
          name$LIKE: this.deviceName
        }
      })).then(res => {
        if(res.status === 200){
          this.deviceList = res.data.result
        }else if(res.status == 401){
          this.$message.error('用户未登录');
        }else{
          console.log('获取设备列表失败')
        }
      })
    },
    getProperties(){
      if (this.activeHasDeviceBinding) {
        const row = (this.deviceList.data || []).find(item => item.id === this.device);
        if (!row) { this.$message.error('请选择当前列表中的设备'); return; }
        const sameProduct = this.activeParameter.productId === row.productId;
        this.setChartParameter('deviceId', row.id);
        this.setChartParameter('deviceName', row.name);
        this.setChartParameter('productId', row.productId);
        this.setChartParameter('productName', row.productName);
        if (!sameProduct) this.selectChartProperty('');
        this.device = ''; this.deviceId = ''; this.deviceName = ''; this.dialogVisible = false;
        return;
      }
      const row = (this.deviceList.data || []).find(item => item.id === this.device);
      if (!row) { this.$message.error('请选择当前列表中的设备'); return; }
      const previousBinding = this.legacyDeviceSettingsKey;
      if (!this.activeObj.parameter) this.$set(this.activeObj, 'parameter', {});
      Object.entries({ deviceId: row.id, productId: row.productId, productName: row.productName, deviceName: row.name, property: '', function: '' })
        .forEach(([key, value]) => this.$set(this.activeObj.parameter, key, value));
      // 物模型由检查器的绑定监听加载，不在确认或拖拽结束时重复请求。
      this.device = ''; this.deviceId = ''; this.deviceName = ''; this.dialogVisible = false;
      if (previousBinding === this.legacyDeviceSettingsKey) this.loadLegacyDeviceSettings();
    },
    deviceClose(value){
      this.deviceVisible = false
      this.config.deviceList = value
    },
    codeClose (value) {
      if (this.code.type === 'query') {
        this.config.query = value;
      } else {
        this.activeObj[this.code.type] = value;
      }
    },
    openCode (type) {
      this.code.type = type;
      if (type === 'query') {
        this.code.obj = this.config.query;
      } else {
        this.code.obj = this.activeObj[type];
      }
      this.code.box = true;
    },
    initFun () {
      ['setScale', 'setResize'].forEach(ele => {
        this[ele] = this.$refs.container[ele]
      });
      ['handleAdd'].forEach(ele => {
        this[ele] = this.$refs.top[ele]
      })
    },
    // 右键菜单
    handleContextMenu (e, item = {}) {
      e.preventDefault();
      if (item.index && !this.active.includes(item.index)) {
        this.active = [item.index];
      }
      if (!item.index) this.handleInitActive();
      this.$nextTick(() => this.$refs.contentmenu.show(e.clientX, e.clientY, !item.index));
    },
    //监听键盘的按键
    listen () {
      this.keyDownListener = event => {
        this.keys.ctrl = event.ctrlKey || event.metaKey;
        if (this.editorVersionSwitching) { event.preventDefault(); return; }
        // 输入框内也接管保存；撤销仍保留输入框自己的行为。
        if (isTextEditing(event.target)) return;
        if (event.key === 'Escape') {
          if (this.$refs.container) this.$refs.container.stopPan();
          if (this.$refs.contentmenu) this.$refs.contentmenu.hide();
          this.handleInitActive();
        }
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'z') {
          event.preventDefault();
          if (event.shiftKey) this.redoStructure(); else this.undoStructure();
        }
      };
      this.keyUpListener = event => { this.keys.ctrl = event.ctrlKey || event.metaKey; };
      this.blurListener = () => { this.keys.ctrl = false; };
      this.saveKeyDownListener = event => {
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
          event.preventDefault();
          if (!event.repeat && !this.editorVersionSwitching && this.$refs.top) this.$refs.top.handleBuild();
        }
      };
      // 捕获阶段接管保存，页面菜单停止冒泡或输入框聚焦时仍然可用。
      document.addEventListener('keydown', this.saveKeyDownListener, true);
      document.addEventListener('keydown', this.keyDownListener);
      document.addEventListener('keyup', this.keyUpListener);
      window.addEventListener('blur', this.blurListener);
    },
    setActive (val, result, fun) {
      if (!this.$refs.container) return;
      const obj = this.$refs.container.handleGetObj(val);
      if (obj && obj[0] && typeof obj[0][fun] === 'function') obj[0][fun](result)
    },
    //批量成组
    handleFloder () {
      this.$refs.contentmenu.handleCompose();
    },
    //批量删除
    handleDeleteSelect () {
      this.$refs.contentmenu.handleDel();
    },
    vaildProp (name, list) {
      if (list) {
        return list.includes(this.activeComponent.prop)
      }
      return (this.dicOption[name] || []).includes(this.activeComponent.prop)
    },
    handleRefresh (tip) {
      this.$refs.container.handleRefresh(tip);
    },
    formatTooltip (val) {
      return parseInt(val);
    },
    //打开图库
    handleOpenImg (item, type) {
      this.$refs.imglist.openImg(item, type);
    },
    //图库框回调赋值
    handleSetimg (val, type) {
      if (type === 'activeObj.data') {
        this.activeObj.data = val;
      } if (type === 'activeObj.data.value') {
        this.activeObj.data.value = val;
      } else if (type === 'activeOption.backgroundImage') {
        this.activeOption.backgroundImage = val;
      } else if (type === 'activeOption.backgroundBorder') {
        this.activeOption.backgroundBorder = val;
      } else if (type === 'activeOption.empBackgroundImage') {
        this.activeOption.empBackgroundImage = val;
      } else if (type === 'config.backgroundImage') {
        this.config.backgroundImage = val;
      } else if (type === 'activeOption.symbol') {
        this.activeOption.symbol = val;
      }
    },
    formatDate(row, column){
      let data = row[column.property];
      if(data === ''){
        return
      }
      let dt = new Date(data);
      return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate() + ' ' + dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    }
  },
  beforeDestroy () {
    clearTimeout(this.historyTimer);
    document.removeEventListener('keydown', this.saveKeyDownListener, true);
    document.removeEventListener('keydown', this.keyDownListener);
    document.removeEventListener('keyup', this.keyUpListener);
    window.removeEventListener('blur', this.blurListener);
  }
}
</script>
<style lang="scss">
@import "../styles/style.scss";
@import "../styles/editor.scss";
</style>
